import { useLazyQuery, useMutation } from "@apollo/client";
import { useRecoilState } from "recoil";

import {
  FOLLOWERS_QUERY,
  FOLLOW_UNFOLLOW_MUTATION,
  MY_FOLLOWERS_QUERY,
} from "../../../GraphQL/followers";
import { AllstarUser } from "../../../State";

export const useFollowers = () => {
  const [allstarUser, setAllstarUser] = useRecoilState(AllstarUser);

  const [mutateFollowers] = useMutation(FOLLOW_UNFOLLOW_MUTATION, {
    refetchQueries: [MY_FOLLOWERS_QUERY, FOLLOWERS_QUERY],
  });

  const [requestUserFollowers] = useLazyQuery(FOLLOWERS_QUERY, {
    fetchPolicy: "cache-and-network",
  });

  const fetchFollowers = async (userId: string) => {
    try {
      const { data: followers } = await requestUserFollowers({
        variables: { userId, profiles: true, clips: false },
      });

      const followingList =
        followers?.getUser?.following?.edges?.map((edge: any) => edge.node) ||
        [];
      const followersList =
        followers?.getUser?.followers?.edges?.map((edge: any) => edge.node) ||
        [];
      const followerCount = followers?.getUser?.followerCount || 0;
      const followingCount = followers?.getUser?.followingCount || 0;

      const followerData = {
        following: followingList,
        followers: followersList,
        followerCount,
        followingCount,
      };

      if (allstarUser.loggedIn && userId === allstarUser.user?._id) {
        setAllstarUser({
          ...allstarUser,
          followers: followerData,
        });
      }

      return followerData;
    } catch (error) {
      return {
        following: [],
        followers: [],
        followerCount: 0,
        followingCount: 0,
      };
    }
  };

  const followUser = async (userId: string, follow: boolean) => {
    try {
      await mutateFollowers({
        variables: { userId, follow },
      });
      return true;
    } catch (error) {
      return false;
    }
  };

  return {
    fetchFollowers,
    followUser,
    mutateFollowers,
  };
};
